class AuthService {
  async refreshAccessToken() {
    const refreshToken = localStorage.getItem("refreshToken");
    const expiredToken = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Authenticate/RefreshToken`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            expiredToken: expiredToken,
            refreshToken: refreshToken,
          }),
        }
      );

      if (response.ok) {
        const responseJson = await response.json();
        localStorage.setItem("token", responseJson.token);
      } else {
        console.log("Cannot refresh token. Try again later...");
      }
    } catch (error) {
      console.error("Error refreshing access token:", error);
    }
  }

  static getHeadersWithAuthToken() {
    const token = localStorage.getItem("token");
    const httpHeaders = {
      Accept: "*/*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
      "Access-Control-Allow-Headers": "Content-Type",
      Authorization: "Bearer " + token,
    };
    return httpHeaders;
  }
  static getHeaders() {
    // const token = localStorage.getItem('token');
    const httpHeaders = {
      Accept: "*/*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    return httpHeaders;
  }
}
export default AuthService;
